/**
 * @author liuming1@sensetime.com
 */
import * as THREE from 'three';

const comparePosition = (pos1, pos2) => {
  return Math.abs(pos1.x - pos2.x) + Math.abs(pos1.y - pos2.y) < 0.01;
};

class Index extends THREE.EventDispatcher {
  /**
     *
     * @param camera
     * @param domElement
     * @param objects
     * @param recursiveDetector 是否递归检测 objects 中子元素的 children
     */
  constructor(camera, domElement, objects, recursiveDetect = false) {
    super();
    this.camera = camera;
    this.domElement = domElement;
    this.objects = objects;
    this.recursiveDetect = recursiveDetect;
    this.enabled = true;
    this.raycaster = new THREE.Raycaster();

    this.mouseDownPos = null;
    this.mouseEnterObj = null;

    this.addListeners();
  }

  addListeners() {
    this.domElement.addEventListener('mousedown', this.onMouseDown, false);
    this.domElement.addEventListener('mouseup', this.onMouseUp, false);
    this.domElement.addEventListener('mousemove', this.onMouseMove, false);
  }

  removeListeners() {
    this.domElement.removeEventListener('mousedown', this.onMouseDown, false);
    this.domElement.removeEventListener('mouseup', this.onMouseUp, false);
    this.domElement.removeEventListener('mousemove', this.onMouseMove, false);
  }

    onMouseDown = (event) => {
      if (this.enabled === false) return;
      // only fired when left mouse
      if (event.button === THREE.MOUSE.LEFT) {
        event.preventDefault();
        const position = this.getEventWorldPosition(event, this.domElement, this.camera);
        this.dispatchEvent({ type: 'mousedown', mapPosition: position, domEvent: event });
        this.mouseDownPos = position;
      }
    };

    onMouseUp = (event) => {
      if (this.enabled === false) return;
      // only fired when left mouse
      if (event.button === THREE.MOUSE.LEFT) {
        event.preventDefault();

        const position = this.getEventWorldPosition(event, this.domElement, this.camera);
        this.dispatchEvent({ type: 'mouseup', mapPosition: position, domEvent: event });

        if (comparePosition(position, this.mouseDownPos)) {
          this.dispatchEvent({ type: 'click', mapPosition: position, domEvent: event });

          this.raycaster.setFromCamera(this.getMousePosition(event), this.camera);
          const intersects = this.raycaster.intersectObjects(this.objects, this.recursiveDetect);
          if (intersects.length > 0) {
            const object = intersects[0].object;
            console.log('detected');
            this.dispatchEvent({ type: 'detected', object });
          }
        }
      }
    };

    onMouseMove = (event) => {
      if (this.enabled === false) return;

      const position = this.getEventWorldPosition(event, this.domElement, this.camera);
      this.dispatchEvent({ type: 'mousemove', mapPosition: position, domEvent: event });

      this.raycaster.setFromCamera(this.getMousePosition(event), this.camera);
      const intersects = this.raycaster.intersectObjects(this.objects, this.recursiveDetect);

      // 从 object 移出去
      if (intersects.length === 0) {
        if (this.mouseEnterObj) {
          this.dispatchEvent({ type: 'mouseleave', object: this.mouseEnterObj });
          this.mouseEnterObj = null;
        }
      }

      if (intersects.length > 0) {
        const object = intersects[0].object;
        // 移动到 object 上
        if (!this.mouseEnterObj) {
          this.dispatchEvent({ type: 'mouseenter', object });
          this.mouseEnterObj = object;
        } else {
          // 两个 object 重叠
          if (object !== this.mouseEnterObj && object) {
            this.dispatchEvent({ type: 'mouseleave', object: this.mouseEnterObj });
            this.mouseEnterObj = object;
            this.dispatchEvent({ type: 'mouseenter', object: this.mouseEnterObj });
          }
        }
      }
    };

    dispose() {
      this.removeListeners();
    }

    getMousePosition(event) {
      const rect = this.domElement.getBoundingClientRect();
      return new THREE.Vector2(
        ((event.clientX - rect.left) / rect.width) * 2 - 1, -((event.clientY - rect.top) / rect.height) * 2 + 1
      );
    }

    getEventWorldPosition = (event, domElement, camera) => {
      const rect = domElement.getBoundingClientRect();

      // Standard x and y in standard coordinate, range from [-1, 1]
      const standardX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      const standardY = -((event.clientY - rect.top) / rect.height) * 2 + 1;

      // Get identity vector from camera to target point
      const vec = new THREE.Vector3().set(standardX, standardY, 0.5);
      vec.unproject(camera);
      vec.sub(camera.position).normalize();

      // Get vector from camera to XY plane
      vec.multiplyScalar(-camera.position.z / vec.z);

      // Get intersect on XY plane
      const pos = new THREE.Vector3().copy(camera.position).add(vec);
      return { x: pos.x, y: pos.y };
    }
}

export default Index;
